import styled, { css } from 'styled-components'
import { ButtonUnstyled } from 'components/Button'

import BaseWorkspaceLogo from '../WorkspaceLogo'

export const Dropzone = styled.div<{ $isDragActive: boolean }>`
  position: absolute;
  z-index: 1;
  top: -4px;
  left: -4px;
  bottom: -4px;
  right: -4px;

  padding: 4px;
  border: 2px dashed ${({ theme }) => theme.colors.border[1]};
  border-radius: ${({ theme }) => theme.radii.xxxlarge};

  ${({ $isDragActive, theme }) =>
    $isDragActive &&
    css`
      border-color: ${theme.colors.primaryTint[100]};
    `}

  cursor: pointer;
  user-select: none;
  * {
    pointer-events: none;
  }
`

export const Container = styled.div`
  position: relative;
`

export const WorkspaceLogo = styled(BaseWorkspaceLogo)`
  background-color: ${({ theme }) => theme.colors.primaryTint[100]};
  color: ${({ theme }) => theme.colors.white};
  border: none;

  /* Border radius is supposed to be like this by design */
  border-radius: 12px; /* stylelint-disable-line scales/radii */

  ::after {
    border: none;
  }
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: ${({ theme }) => theme.fontSizes.little};
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.foreground.secondary[3]};

  /* Border radius is supposed to be like this by design */
  border-radius: 12px; /* stylelint-disable-line scales/radii */

  transition: opacity ease-in-out 100ms;
`

export const ToggleWrapper = styled(ButtonUnstyled)`
  position: relative;
  display: block;

  ${Overlay} {
    opacity: 0;
  }

  :hover,
  :focus,
  :focus-within {
    ${Overlay} {
      opacity: 1;
    }
  }
`
